// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"c2323ae413f562a8888f","339":"e8a35ada1d23b1520764"}[chunkId] + ".js";
};